"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ignoredMessages_1 = __importDefault(require("./ignoredMessages"));
const ignoredStack_1 = __importDefault(require("./ignoredStack"));
const ignoredUserAgents_1 = __importDefault(require("./ignoredUserAgents"));
const supported_browsers_1 = __importDefault(require("@betterplace/supported-browsers"));
const IgnoredUserAgentsRegexp = new RegExp(ignoredUserAgents_1.default.join('|'), 'i');
const IgnoredMessagesRegexp = new RegExp(ignoredMessages_1.default.join('|'), 'i');
const beforeNotifyHandler = (notice) => {
    if (!notice)
        return false;
    if (typeof navigator !== 'undefined') {
        if (!supported_browsers_1.default.test(navigator?.userAgent))
            return false;
        if (IgnoredUserAgentsRegexp.test(navigator?.userAgent))
            return false;
    }
    if (ignoredStack_1.default.test(notice.stack))
        return false;
    if (ignoredStack_1.default.test(notice.backtrace?.join('')))
        return false;
    if (IgnoredMessagesRegexp.test(notice.message))
        return false;
};
exports.default = beforeNotifyHandler;
//# sourceMappingURL=beforeNotifyHandler.js.map